export class WorkspaceSerializer {
    static CURRENT_VERSION = 1;
    static serialize(panes, drawings, settings) {
        const workspace = {
            version: this.CURRENT_VERSION,
            timestamp: Date.now(),
            panes,
            drawings,
            settings,
        };
        return JSON.stringify(workspace, null, 2);
    }
    static deserialize(jsonString) {
        try {
            if (!jsonString)
                return null;
            const parsed = JSON.parse(jsonString);
            if (typeof parsed !== "object" || parsed === null) {
                return null;
            }
            // Validate schema version
            if (typeof parsed.version !== "number" || parsed.version > this.CURRENT_VERSION) {
                console.warn(`Unsupported workspace schema version: ${parsed.version}`);
                return null;
            }
            // Validate essential arrays
            if (!Array.isArray(parsed.panes)) {
                parsed.panes = [];
            }
            if (!Array.isArray(parsed.drawings)) {
                parsed.drawings = [];
            }
            if (typeof parsed.settings !== "object" || parsed.settings === null) {
                parsed.settings = {};
            }
            return parsed;
        }
        catch (err) {
            console.warn("Failed to deserialize workspace JSON:", err);
            return null;
        }
    }
}
